var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EChart',{staticClass:"shadow-none m-0",attrs:{"options":_vm.chartOptions,"card":"","header":_vm.$t('priceRangeAndDeviations'),"loading":_vm.loading,"tooltip":_vm.$t('chartHeaderTooltip')}})
}
var staticRenderFns = []

export { render, staticRenderFns }